import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment GuideCommentOverviewItem on GuideCommentModel {
    id
    text
    status
    guide {
      id
      docName
      docTitle
      owner {
        subjectId
        name
      }
    }
    externalUserEmail
    createdBy {
      subjectId
      name
    }
    createdAt
    updatedBy {
      subjectId
      name
    }
    updatedAt
    closedAt
    closedBy {
      subjectId
      name
    }
    replies {
      id
      comment
      createdBy {
        subjectId
        name
      }
      createdAt
      updatedAt
    }
  }
`);

export const GET_EXTERNAL_COMMENTS = gql(/* GraphQL */ `
  query GetAllComments {
    comments(where: { type: { eq: CUSTOMER_FEEDBACK } }, order: { createdAt: DESC }) {
      ...GuideCommentOverviewItem
    }
  }
`);

gql(/* GraphQL */ `
  fragment CategoryCommentOverviewItem on CategoryCommentModel {
    id
    text
    status
    category {
      id
      title
      owner {
        subjectId
        name
      }
    }
    externalUserEmail
    createdBy {
      subjectId
      name
    }
    createdAt
    updatedBy {
      subjectId
      name
    }
    updatedAt
    closedAt
    closedBy {
      subjectId
      name
    }
    replies {
      id
      comment
      createdBy {
        subjectId
        name
      }
      createdAt
      updatedAt
    }
  }
`);

export const GET_EXTERNAL_CATEGORY_COMMENTS = gql(/* GraphQL */ `
  query GetAllCategoryComments {
    categoryComments(where: { type: { eq: CUSTOMER_FEEDBACK } }, order: { createdAt: DESC }) {
      ...CategoryCommentOverviewItem
    }
  }
`);
